<template>
  <li class="faq-accordion" :class="{ 'faq-accordion--open': selected }">
    <button
      type="button"
      class="faq-accordion__trigger"
      :aria-expanded="selected"
      :aria-controls="answerId"
      @click="selected = !selected"
    >
      <span v-if="index" class="faq-accordion__index" aria-hidden="true">{{ String(index).padStart(2, '0') }}</span>
      <span class="faq-accordion__title">{{ accordion.title }}</span>
      <span class="faq-accordion__icon" aria-hidden="true">
        <ChevronDownIcon :size="20" />
      </span>
    </button>

    <transition name="slide">
      <div v-show="selected" :id="answerId" class="faq-accordion__panel" role="region" :aria-label="accordion.title">
        <div class="faq-accordion__content" v-html="accordion.description">
        </div>
      </div>
    </transition>
  </li>
</template>
<script>
export default {
  name: 'BaseAccordion',
  props: {
    accordion: {
      type: Object,
      required: true,
    },
    accordionId: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      selected: false,
    }
  },
  computed: {
    answerId() {
      return this.accordionId ? `${this.accordionId}-answer` : undefined
    },
  },
}
</script>
<style scoped>
.faq-accordion {
  overflow: hidden;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #fff;
  box-shadow: 0 9px 22px -20px rgba(15, 23, 42, 0.62);
  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;
}

.faq-accordion:hover {
  border-color: #cbd5e1;
  box-shadow: 0 16px 30px -24px rgba(15, 23, 42, 0.62);
}

.faq-accordion--open {
  border-color: rgba(13, 148, 136, 0.36);
  box-shadow: 0 18px 36px -25px rgba(15, 118, 110, 0.42);
}

.faq-accordion__trigger {
  display: flex;
  width: 100%;
  min-height: 4.5rem;
  align-items: center;
  gap: 0.75rem;
  padding: 0.9rem 1rem;
  color: #172033;
  text-align: left;
  transition: background 180ms ease, color 180ms ease;
}

.faq-accordion__trigger:hover,
.faq-accordion--open .faq-accordion__trigger {
  background: linear-gradient(90deg, rgba(240, 253, 250, 0.92), rgba(255, 255, 255, 0));
}

.faq-accordion__trigger:focus-visible {
  outline: 3px solid rgba(20, 184, 166, 0.55);
  outline-offset: -3px;
}

.faq-accordion__index {
  width: 1.7rem;
  flex: 0 0 auto;
  color: #0f766e;
  font-size: 0.69rem;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.faq-accordion__title {
  flex: 1;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1.45;
}

.faq-accordion__icon {
  display: flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 9999px;
  color: #0f766e;
  transition: transform 220ms ease, background 180ms ease, border-color 180ms ease;
}

.faq-accordion--open .faq-accordion__icon {
  transform: rotate(180deg);
  border-color: #99f6e4;
  background: #ccfbf1;
}

.faq-accordion__panel {
  overflow: hidden;
}

.faq-accordion__content {
  margin: 0 1rem 1rem;
  border-left: 2px solid #99f6e4;
  padding: 0.15rem 0 0.15rem 1rem;
  color: #475569;
  font-size: 0.925rem;
  line-height: 1.8;
  overflow-wrap: anywhere;
}

.faq-accordion__content :deep(p) {
  margin: 0 0 0.9rem;
}

.faq-accordion__content :deep(p:last-child) {
  margin-bottom: 0;
}

.faq-accordion__content :deep(ul),
.faq-accordion__content :deep(ol) {
  margin: 0.75rem 0;
  padding-left: 1.2rem;
}

.faq-accordion__content :deep(li + li) {
  margin-top: 0.35rem;
}

.slide-enter-active,
.slide-leave-active {
  transition: opacity 180ms ease, transform 180ms ease;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateY(-0.4rem);
}

@media (min-width: 640px) {
  .faq-accordion__trigger {
    min-height: 5rem;
    gap: 1rem;
    padding: 1rem 1.25rem;
  }

  .faq-accordion__title {
    font-size: 1rem;
  }

  .faq-accordion__content {
    margin: 0 1.25rem 1.2rem 1rem;
    padding-left: 1.15rem;
    font-size: 0.975rem;
  }
}
</style>
